// Handle i18next with TypeScript
import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';

// Import translations
import enTranslation from './locales/en';
import zhTranslation from './locales/zh';
import thTranslation from './locales/th';

// Define the available languages
export const languages = {
  en: { nativeName: 'English' },
  zh: { nativeName: '中文' },
  th: { nativeName: 'ไทย' }
};

// Get saved language preference
const savedLanguage = localStorage.getItem('language');

// Force TypeScript to accept i18n
const i18nInstance = (i18n as any);

i18nInstance
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    debug: import.meta.env.DEV,
    fallbackLng: 'en',
    lng: savedLanguage || undefined,
    interpolation: {
      escapeValue: false,
    },
    detection: {
      order: ['localStorage', 'navigator'],
      caches: ['localStorage'],
    },
    resources: {
      en: {
        translation: enTranslation,
      },
      zh: {
        translation: zhTranslation,
      },
      th: {
        translation: thTranslation,
      },
    },
    // Disable JSON file loading via URL - we're using imported modules instead
    backend: {
      loadPath: '',
    },
  });

export default i18nInstance; 